@use '@/styles/tokens' as *;

// Figma chip (node 121:1927): 18px pill, Geist 11px, stage colorways.

.chip {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 2px;
  min-height: 18px;
  padding: 3px 8px;
  border-radius: 24px;
  font-size: 11px;
  font-weight: 400;
  line-height: 1;
  white-space: nowrap;
}

.neutral {
  background: $color-neutral-200;
  color: var(--text-primary);
}

.wip {
  background: $color-stage-wip-bg;
  color: $color-stage-wip-text;
}

.review {
  background: $color-stage-review-bg;
  color: $color-stage-review-text;
}

.approved {
  background: $color-stage-approved-bg;
  color: $color-brand-700;
}

.attention {
  background: $color-error-100;
  color: $color-stage-attention-text;
}

.published {
  background: $color-info-100;
  color: $color-info-700;
}

.icon {
  display: inline-flex;

  > svg {
    width: 10px;
    height: 10px;
  }
}
